import {
  useIntegration,
  useResolvedIntegration
} from 'services/integration/hooks';
import { NoATSAnalyseCreation } from 'pages/Analyse/NoATSAnalyseCreation';
import { ATSAnalyseCreation } from 'pages/Analyse/ATSAnalyseCreation';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetCandidateBatchQuery } from 'generated-graphql/hooks/apollo-hooks';
import { extractQueryGetItem } from 'core/utils/apollo/extractGetItem';
import { LoadingIndicator } from 'common/ui/LoadingIndicator';
import { ATS_LOOKUP_LOADING_TITLE } from 'services/integration/constants';

export const AnalyseCreation = () => {
  const { isConnected } = useIntegration();
  const { isIntegrationResolved } = useResolvedIntegration();
  const { id: candidateBatchId } = useParams();
  const navigate = useNavigate();

  const { data: candidateBatchData, loading: candidateBatchLoading } =
    useGetCandidateBatchQuery({
      variables: {
        id: candidateBatchId as string
      },
      skip: !candidateBatchId
    });

  const candidateBatch = extractQueryGetItem(candidateBatchData);

  if (candidateBatchId) {
    if (candidateBatchLoading) {
      return <LoadingIndicator />;
    }

    if (candidateBatch?.atsJobId) {
      return <ATSAnalyseCreation candidateBatch={candidateBatch} />;
    }

    // TODO: Handle Draft No ATS job - It is not supported now
    // navigate back to the previous page
    navigate(-1);
  }

  // Wait for the ATS lookup before choosing a flow. `isConnected` is false both
  // when no ATS is connected and while the answer is still in flight, so
  // branching on it directly renders the non-ATS form to an ATS org and then
  // replaces it with "Choose jobs" once the lookup lands — discarding whatever
  // job description the recruiter had started typing.
  if (!isIntegrationResolved) {
    return <LoadingIndicator title={ATS_LOOKUP_LOADING_TITLE} />;
  }

  if (isConnected) {
    return <ATSAnalyseCreation />;
  }

  return <NoATSAnalyseCreation />;
};
